import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-input" }
const _hoisted_2 = { class: "checkbox-item" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["for"]


  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomCheckbox',
  props: /*#__PURE__*/_mergeModels({
    id: {},
    inputClass: { default: null },
    label: { default: null }
  }, {
    "modelValue": { type: [Boolean, null] },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

  const props = __props;

  const modelValue = _useModel<boolean | null | undefined>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        id: props.id,
        class: _normalizeClass(['checkbox-input', props.inputClass]),
        type: "checkbox"
      }, null, 10, _hoisted_3), [
        [_vModelCheckbox, modelValue.value]
      ]),
      _createElementVNode("label", {
        class: "checkbox-label",
        for: props.id
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(props.label), 1)
      ], 8, _hoisted_4)
    ])
  ]))
}
}

})